import React from 'react'
import { ServerConfig } from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'

// Staff / admin Support Keyword management (PR > Support > Keywords).
//
// Backend routes (views/support.py, admin_blueprint):
//   GET  /admin/support/keywords              -> list (PaginatedList list_get_url)
//   POST /admin/support/keywords              -> create canonical keyword (add_new_url)
//   GET  /admin/support/keywords/detail/:id   -> single keyword (detail_get_url)
//   PUT  /admin/support/keywords/detail/:id   -> rename keyword (detail_put_url)
//
// Synonyms are managed via their own routes (not through PaginatedList):
//   GET    /admin/support/keywords/:id/synonyms
//   POST   /admin/support/keywords/:id/synonyms
//   DELETE /admin/support/synonyms/:id

const SupportKeywords = () => {
  const editable_fields = [
    ["keyword", "Keyword"],
    ["synonyms", "Synonyms", "synonyms"],
    ["delete", "Delete", "delete"],
  ];

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/support/keywords/`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/support/keywords/detail/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/support/keywords/detail/`}
        add_new_url={`${ServerConfig.SERVER_URL}/admin/support/keywords`}

        column_names={["keyword", "edit"]}
        header_names={["Keyword", ""]}

        optional_column_names={["normalized_keyword"]}
        optional_header_names={["Normalized"]}

        editable_fields={editable_fields}
      />
    </>
  )
}

export default SupportKeywords